import React from 'react';
import { Search, Filter } from 'lucide-react';
import { Input } from '@/components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

interface MemberFiltersProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  planFilter: string;
  onPlanFilterChange: (plan: string) => void;
  statusFilter: string;
  onStatusFilterChange: (status: string) => void;
}

export const MemberFilters: React.FC<MemberFiltersProps> = ({
  searchQuery,
  onSearchChange,
  planFilter,
  onPlanFilterChange,
  statusFilter,
  onStatusFilterChange,
}) => {
  return (
    <div className="space-y-3">
      {/* Search */}
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-white/40" />
        <Input
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Buscar miembro..."
          className="pl-10 bg-white/10 border-white/20 text-white placeholder:text-white/40"
        />
      </div>
      
      {/* Filters row */}
      <div className="flex gap-2">
        <Select value={planFilter} onValueChange={onPlanFilterChange}>
          <SelectTrigger className="bg-white/10 border-white/20 text-white flex-1 h-9 text-xs">
            <Filter className="w-3 h-3 mr-1 text-white/50" />
            <SelectValue placeholder="Plan" />
          </SelectTrigger>
          <SelectContent className="bg-slate-800 border-white/20">
            <SelectItem value="todos" className="text-white hover:bg-white/10">Todos</SelectItem>
            <SelectItem value="oro" className="text-yellow-400 hover:bg-white/10">🥇 Oro</SelectItem>
            <SelectItem value="plata" className="text-gray-300 hover:bg-white/10">🥈 Plata</SelectItem>
            <SelectItem value="bronce" className="text-amber-400 hover:bg-white/10">🥉 Bronce</SelectItem>
          </SelectContent>
        </Select>
        
        <Select value={statusFilter} onValueChange={onStatusFilterChange}>
          <SelectTrigger className="bg-white/10 border-white/20 text-white flex-1 h-9 text-xs">
            <SelectValue placeholder="Estado" />
          </SelectTrigger>
          <SelectContent className="bg-slate-800 border-white/20">
            <SelectItem value="todos" className="text-white hover:bg-white/10">Todos</SelectItem>
            <SelectItem value="activo" className="text-green-400 hover:bg-white/10">✓ Activo</SelectItem>
            <SelectItem value="pausado" className="text-amber-400 hover:bg-white/10">⏸ Pausado</SelectItem>
            <SelectItem value="sin-plan" className="text-red-400 hover:bg-white/10">✗ Sin plan</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};

export default MemberFilters;
